<template>
  <div class="seletor">
    <h2 class="box-title">Selecionar ponto</h2>
    <div class="combo-box-wrapper">
      <ComboBox title="Pontos" :options="textoPontos" @update="handleSelection"></ComboBox>
    </div>
    <div class="btn-wrapper">
      <Button @click.native="handleConfirm">Confirmar</Button>
    </div>
  </div>
</template>

<script>
import api from "../services/api";
import Button from "./Button";
import ComboBox from "./ComboBox";

export default {
  name: "SeletorPonto",
  components: {
    Button,
    ComboBox
  },
  data: () => ({
    pontos: [],
    selected: -1
  }),
  async created() {
    const res = await api().get("/ObterPontosVisualizacao");
    this.pontos = res.data;
  },
  methods: {
    async handleConfirm() {
      //Cadastra o seq do ponto selecionado e os modelos referentes a esse ponto
      if (this.selected >= 0) {
        const seqPonto = this.pontos[this.selected].SEQ_PONTO_VISUALIZACAO;
        this.$emit("selected", seqPonto);
      } else alert("Nenhum ponto selecionado");
    },
    handleSelection(index) {
      this.selected = index;
    }
  },
  computed: {
    textoPontos: function() {
      return this.pontos.map(
        ponto =>
          ponto.COD_PONTO_VISUALIZACAO + " / " + ponto.DSC_PONTO_VISUALIZACAO
      );
    }
  }
};
</script>

<style scoped>
.seletor {
  border-radius: 0.8rem;
  margin: 0 auto;
  width: 60%;
  padding-bottom: 3rem;
  background: #263238;
  background: var(--color-secondary);
  margin-top: 4rem;
  display: flex;
  flex-direction: column;
}

.box-title {
  font-size: 4.2rem;
  text-align: center;
  padding: 1rem;
  background: #37474f;
  background: var(--color-tertiary);
  border-top-left-radius: 0.8rem;
  border-top-right-radius: 0.8rem;
  box-shadow: 0 1.75rem 1.25rem -1.25rem rgba(33, 33, 33, 0.25);
}

.combo-box-wrapper {
  display: flex;
  justify-content: center;
  font-size: 2.2rem;
  margin: 8.5rem 0;
}

.btn-wrapper {
  display: flex;
  justify-content: center;
  font-size: 2.2rem;
}
</style>